import { COMMON } from "../../util/localizations"

const TRANSLATIONS = {
    en: {
        event: COMMON.en.event,
        nodeType: COMMON.en.nodeType,
        organization: COMMON.en.organization,
        person: COMMON.en.person,
        place : COMMON.en.place
    }
}

export default TRANSLATIONS